import React, { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom"; // ✅ Import

interface VisaTrackerFormProps {
  onTrack?: (trackingId: string) => void;
}

export const VisaTrackerForm: React.FC<VisaTrackerFormProps> = ({ onTrack }) => {
  const [trackingId, setTrackingId] = useState("");
  const navigate = useNavigate(); // ✅ Initialize router navigation

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onTrack) {
      onTrack(trackingId);
    } else {
      // ✅ Use navigate instead of window.location.href
      navigate(`/TrackOrder/${encodeURIComponent(trackingId)}`);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col sm:flex-row gap-2 items-center bg-white p-2 rounded-lg shadow-lg max-w-md mx-auto"
    >
      <div className="w-full">
        <label htmlFor="tracking-input" className="sr-only">
          Enter your reference or passport number
        </label>
        <Input
          id="tracking-input"
          placeholder="Reference No. / Passport No. / Application ID"
          className="border-0 focus:ring-0 focus-visible:ring-offset-0 focus-visible:ring-0"
          value={trackingId}
          onChange={(e) => setTrackingId(e.target.value)}
        />
      </div>
      <Button
        type="submit"
        className="w-full sm:w-auto flex-shrink-0"
        disabled={!trackingId}
      >
        <Search className="mr-2 h-4 w-4" />
        Track My Visa
      </Button>
    </form>
  );
};
